

// import  '../styles/sass/style.scss';
import  '../styles/style.scss';
import  '../icons/arna-icons.css';

import 'owl.carousel/dist/assets/owl.carousel.css';





require('bootstrap');




// Bootstrap js
// import "bootstrap/js/dist/collapse";
import "bootstrap/dist/js/bootstrap.min";


// ui Plugins
import 'owl.carousel';
// import 'nouislider';
import 'wnumb';
// import 'plyr/dist/plyr';
// import Plyr from "plyr";




import 'nouislider/dist/nouislider.min.css';





// other Functions
import {menuMobile} from './js-components/menuMobile.js';
import {sliderTabSelected} from './js-components/sliderTabSelected.js';
import {radioButton} from './js-components/radioButton.js';
import {priceRangeSlider} from './js-components/priceRangeSlider.js';
import {requestBanksDetails} from './js-components/requestBanksDetails.js';
import {checkboxButton} from './js-components/checkboxButton';
import {submenuHoverOpenV2} from './js-components/subMenuHover.js';
import {scrollDownAnimationDeskItems} from './js-components/scrollDownAnimationDeskItems.js';
import {faqCollapse} from './js-components/faqCollapse.js';
import {showModalFastSignup} from './js-components/showModalFastSignup.js';



jQuery( document ).ready(function() {

    menuMobile();
    sliderTabSelected();
    radioButton();
    priceRangeSlider();
    $('.prcformsec-tpl-m7 .pfin-m7 .btn-t').on('mouseup', function (){
        requestBanksDetails();
    })
    if (jQuery(".js-single-loan").length) {
        var dataTableParam = {
            category_id: category_id
        }
        requestBanksDetails(dataTableParam);
    }
    checkboxButton();
    submenuHoverOpenV2();
    scrollDownAnimationDeskItems();
    faqCollapse();
    showModalFastSignup();

});
